export default "__VITE_ASSET__YSKiO8Rz__"